module.exports = __webpack_public_path__ + "static/media/vaccines.05ffd964.png";